import React, { createContext, useState, useEffect, useContext } from 'react';
import { CallApi } from '../Request';

// I created a simple lookup map for country languages so we do not have to import a library
// You could add any other countries that the application supports here like this: <ISO 3166 Country Code>: ['<language key>'],
const countryLanguagesMap: { [key: string]: string[] } = {
  US: ['en'], JP: ['ja'],
};

interface LanguageContextType {
  language: string;
  setLanguage: React.Dispatch<React.SetStateAction<string>>;
}

export const LanguageContext = createContext<LanguageContextType>({
  language: 'en',
  setLanguage: () => console.warn('Language context not ready'),
});

export const LanguageProvider = ({ children }: { children: React.ReactNode }) => {
    const [language, setLanguage] = useState<string>('en');

    useEffect(() => {
        const determineLanguage = () => {
            const browserLang = navigator.language.split('-')[0];

            if (browserLang === 'en') {
                CallApi({
                    url: `users/location`,
                    method: 'get'
                }).then((res) => {
                    const languages = countryLanguagesMap[res.country.toUpperCase()] || [];
                    const firstOfficialLanguage = languages.find(lang => lang !== 'en') || 'en';
                    setLanguage(firstOfficialLanguage);
                }).catch((error) => {
                    console.error("Error fetching user location for language:", error);
                    setLanguage('en');
                });
            } else {
                setLanguage(browserLang);
            }
        };

        determineLanguage();
    }, []);
    const value = { language, setLanguage };

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    return useContext(LanguageContext);
};